// MapboxStyleIds maps a stable mapbox style key to the id of each style in Mapbox.
// These names are wordy, but they make it much easier to search the code. Searching for styles like "alltrails" or "satellite" can be tricky.
// These names are consistent with what we use in our k8s templates.
export type MapboxStyleIds = {
  mapbox3DBaseMapStyleId: string;
  mapboxAllTrailsStyleId: string;
  mapboxSatelliteStyleId: string;
  mapboxTerrainStyleId: string;
  mapboxWorldTopoTerrainStyleId: string;
};

// getMapboxStyleIds returns the mapbox style ids for the current environment
export function getMapboxStyleIds(): MapboxStyleIds {
  const mapboxStyleIds = {
    mapbox3DBaseMapStyleId: process.env.MAPBOX_3D_BASE_MAP_STYLE_ID,
    mapboxAllTrailsStyleId: process.env.MAPBOX_ALLTRAILS_STYLE_ID,
    mapboxSatelliteStyleId: process.env.MAPBOX_SATELLITE_STYLE_ID,
    mapboxTerrainStyleId: process.env.MAPBOX_TERRAIN_STYLE_ID,
    mapboxWorldTopoTerrainStyleId: process.env.MAPBOX_WORLD_TOPO_TERRAIN_STYLE_ID
  };

  Object.keys(mapboxStyleIds).forEach(id => {
    if (!mapboxStyleIds[id]) {
      throw new Error(`Missing mapbox style id "${id}"`);
    }
  });

  return mapboxStyleIds as MapboxStyleIds;
}
